module.exports = __webpack_public_path__ + "img/virtual_tour.d100db31.jpg";